import React from 'react';
import '../template-file-css/document-file-template.css';


export const GFIT_PsychotropicMedConsent = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GFIT_PsychotropicMedConsent' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    <center>
                        <h3>
                            Informed Consent for Psychotropic Medication
                        </h3>
                    </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Client Name: </span></td>
                        <td className='w-375'> <span className='eleHeader'> DOB: </span></td>
                    </tr>

                    <tr>
                        <td className='w-375'><input id='txtClientName' name='txtClientName' type='text' className='add-only' /></td>
                        <td className='w-375'><input id='txtDob' name='txtDob' type='date' className='add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Insurance: </span></td>
                        <td className='w-375'> <span className='eleHeader'> Insurance ID #: </span></td>
                    </tr>

                    <tr>
                        <td className='w-375'><input id='txtInsurance' name='txtInsurance' type='text' className='add-only' /></td>
                        <td className='w-375'><input id='txtInsuranceId' name='txtInsuranceId' type='text' className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'> <b> Prescribed Psychotropic Medication: </b> </p>


                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Medication Name: </span></td>
                        <td className='w-250'> <span className='eleHeader'> Date prescribed: </span></td>
                    </tr>

                    <tr>
                        <td className='w-500'><input id='txtMedicationName_1' name='txtMedicationName_1' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtDatePrescribed_1' name='txtDatePrescribed_1' type='date' className='add-only' /></td>
                    </tr> 
                    <tr>
                        <td className='w-500'><input id='txtMedicationName_2' name='txtMedicationName_2' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtDatePrescribed_2' name='txtDatePrescribed_2' type='date' className='add-only' /></td>
                    </tr> 
                    <tr>
                        <td className='w-500'><input id='txtMedicationName_3' name='txtMedicationName_3' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtDatePrescribed_3' name='txtDatePrescribed_3' type='date' className='add-only' /></td>
                    </tr> 
                    <tr>
                        <td className='w-500'><input id='txtMedicationName_4' name='txtMedicationName_4' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtDatePrescribed_4' name='txtDatePrescribed_4' type='date' className='add-only' /></td>
                    </tr> 
                    <tr>
                        <td className='w-500'><input id='txtMedicationName_5' name='txtMedicationName_5' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtDatePrescribed_5' name='txtDatePrescribed_5' type='date' className='add-only' /></td>
                    </tr> 
                    <tr>
                        <td className='w-500'><input id='txtMedicationName_6' name='txtMedicationName_6' type='text' className='add-only' /></td>
                        <td className='w-250'><input id='txtDatePrescribed_6' name='txtDatePrescribed_6' type='date' className='add-only' /></td>
                    </tr> 
                </table> 


                <p className='w-750'>
                    <span className='eleHeader'> Medication discontinued: </span>
                    <input type='radio' id='rbMedicationDiscontinued_yes' name='rbYes' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMedicationDiscontinued_no' name='rbNo' className='add-only' value='No' /> No &nbsp;
                </p>

                <p className='w-750'>
                    I, <input type='text' id='txtName' name='txtName' className='add-only w-300 custom-add-only' /> (consumer 18 and above or guardian of minor), hereby consent to psychotropic medication as prescribed by my provider. I have been informed of all the possible side effects and adverse reactions to the medications. I understand that I must consult with my provider before discontinuing the medication.
                </p>


                <table>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Consumer or Guardian Full Name</span> </td>
                        <td className='w-375'> <span className='eleHeader'>date</span> </td>
                    </tr>

                    <tr>
                        <td className='w-375'>  <input id='txtConsumerGuardian' name='txtConsumerGuardian' type='text' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                    </tr>

                </table>

                {/* <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='w-375'>Consumer or Guardian Signature</span> </td>
                    </tr>

                </table> */}

                <br></br>


                <p className='w-750'>
                    In general terms, I have discussed the above medication(s) with the consumer/parent/legal guardian. Expected results, common side effects, and possible risks were discussed and presented in a clear and reasonable manner consistent with his/her abilities of comprehension and understanding. Alternatetreatments (including no treatment and its consequences) were also discussed. Consumer was also made aware that he/she may refuse medication and withdraw consent. I informed him/her that it may be unsafe for the consumer or others if medication is refused. In this case, under certain circumstances, the consumer may be medicated involuntarily.
                </p>


                {/* <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Witness Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table> */}






            </div>
        </form>

    )
}